import { supabase } from '../lib/supabase';

export const sendApplicationStatusEmail = async (
  studentId: string,
  status: 'approved' | 'rejected',
  comments?: string
) => {
  try {
    const { data: functionUrl } = await supabase
      .functions
      .invoke('notify-application-status', {
        body: JSON.stringify({
          studentId,
          status,
          comments,
        }),
      });

    return functionUrl;
  } catch (error) {
    console.error('Error sending status email:', error);
    throw error;
  }
};

export const sendApplicationSubmissionEmail = async (email: string, studentName: string) => {
  try {
    const { data: functionUrl } = await supabase
      .functions
      .invoke('notify-application-status', {
        body: JSON.stringify({
          email,
          studentName,
          type: 'submission',
        }),
      });

    return functionUrl;
  } catch (error) {
    console.error('Error sending submission email:', error);
    throw error;
  }
};

export const sendLeaseSignedEmail = async (email: string, studentName: string) => {
  try {
    const { data: functionUrl } = await supabase
      .functions
      .invoke('notify-application-status', {
        body: JSON.stringify({
          email,
          studentName,
          type: 'lease_signed',
        }),
      });

    return functionUrl;
  } catch (error) {
    console.error('Error sending lease signed email:', error);
    throw error;
  }
};

export const sendInvoiceEmail = async (
  email: string,
  studentName: string,
  invoiceNumber: string,
  amount: number,
  dueDate: string,
  startDate?: string,
  endDate?: string
) => {
  try {
    const { data: functionUrl } = await supabase
      .functions
      .invoke('notify-invoice', {
        body: JSON.stringify({
          email,
          studentName,
          invoiceNumber,
          amount,
          dueDate,
          startDate,
          endDate,
        }),
      });

    return functionUrl;
  } catch (error) {
    console.error('Error sending invoice email:', error);
    throw error;
  }
};